import {gql} from "@apollo/client";

export const getPlateAlternatives = gql`
  query getPlateAlternatives {
    plates {
      id
      name
      image
      details
      ingredientsCount
      category{ id, name }
    }
  }
`

export const createPlateHistory = gql`
  mutation createPlateHistory($image: Upload, $comment: String, $id: ID!, $rating: String, $action: String!) {
    createPlateHistory(input: {
      id: $id,
      image: $image,
      comment: $comment
      rating: $rating
      action: $action
    }) {
      menuItem{
        id
      }
    }
  }
`;

export const AddToCartMutation = gql`
  mutation addToCart($id: ID!) {
    addToCart(input: {id: $id}) {
      plate{
        id
      }
    }
  }
`;

